// import React, { useEffect, useState } from "react";
// import $ from "jquery"
// import DatePicker from "react-datepicker";
// import 'react-datepicker/dist/react-datepicker.css';
// import "./style.css"
// import { convertDDMMYYYY, convertMMDDYYYY, convertToFullDate } from "../../Utils/function";
// function AuditFormAnswerFieldUi({
//   values,
//   formik,
//   index,
//   subQuestion,
//   handleSubQuestionChange,
// }) {
//   const [mappedValues, setMappedValues] = useState([]);

//   useEffect(() => {
//     // Calculate the difference between b and a
//     const difference = parseFloat(values?.max) - parseFloat(values?.min);
//     // Create an array of mapped values
//     const valuesT = [];
//     for (let i = 0; i <= difference; i++) {
//       const mappedValue = parseFloat(values?.min) + i;
//       valuesT.push(mappedValue);
//     }
//     // Set the mapped values to state
//     if (valuesT.length > 1) {
//       setMappedValues(valuesT);
//     }
//   }, [values?.min, values?.max]);
//   const handleCheckboxChange = (option) => {
//     const currentAnswers = values?.answer || [];
//     const newAnswers = currentAnswers.includes(option)
//       ? currentAnswers.filter((item) => item !== option) // Remove if already selected
//       : [...currentAnswers, option]; // Add if not selected
//     if (subQuestion) {
//       handleSubQuestionChange(index, newAnswers, "answer");
//     }
//   };
//   const [selectedDate, setSelectedDate] = useState(null);
//   return (
//       <div className="row">
//         <div></div>
//       <div className="col-6">
//       {values?.input_type === "date" && (
//     //     <div class="input-group date" id="reservationdate" data-target-input="nearest">
//     //     <input type="text" class="form-control datetimepicker-input" data-target="#reservationdate"/>
//     //     <div class="input-group-append" data-target="#reservationdate" data-toggle="datetimepicker">
//     //         <div class="input-group-text"><i class="fa fa-calendar"></i></div>
//     //     </div>
//     // </div>
//     <div className="input-group date" style={{width:"100%"}}>
//     <DatePicker
//       selected={values?.answer[0]  ? convertToFullDate(values?.answer[0]) : new Date()}
//       name={`answer[${0}]`}
//       {...(subQuestion
//         ? {
//             onChange: (date) =>
//               handleSubQuestionChange(index, [convertDDMMYYYY(date)], "answer"),
//           }
//         : {
//           onChange: (date) =>
//             formik?.setFieldValue(`answer[${0}]`, convertDDMMYYYY(date)), // Update the value in the array
//         })}
//       dateFormat="dd/MM/yyyy" // Adjust format as needed
//       className={`form-control datetimepicker-input${
//         formik?.errors?.answer && formik?.touched?.answer
//           ? "is-invalid border-danger"
//           : ""
//       }`}
//       placeholderText="Select a date"

//     />
//     <div className="input-group-append">
//       <div className="input-group-text">
//         <i className="fa fa-calendar"></i>
//       </div>
//     </div>
//   </div>
//         )}
//         {values?.input_type === "text" && !values?.multiline && (
//           <input
//             type="text"
//             className={`form-control ${
//               formik?.errors?.answer && formik?.touched?.answer
//                 ? "is-invalid border-danger"
//                 : ""
//             }`}
//             value={values?.answer !== null ? values?.answer[0] : ""}
//             name={`answer[${0}]`}
//             placeholder="Enter Answer"
//             {...(subQuestion
//               ? {
//                   onChange: (e) =>
//                     handleSubQuestionChange(index, [e.target.value], "answer"),
//                 }
//               : {
//                 onChange: (e) =>
//                   formik?.setFieldValue(`answer[${0}]`, e.target.value), // Update the value in the array
//               })}
//           />
//         )}
//         {values?.input_type === "text" && values?.multiline && (
//           <textarea
//             type="text"

//             className={`form-control ${
//               formik?.errors?.answer && formik?.touched?.answer
//                 ? "is-invalid border-danger"
//                 : ""
//             }`}
//             placeholder="Enter Answer"
//             value={values?.answer !== null ? values?.answer[0] : ""}
//             name={`answer[${0}]`}
//             {...(subQuestion
//               ? {
//                   onChange: (e) =>
//                     handleSubQuestionChange(index, [e.target.value], "answer"),
//                 }
//               : {
//                 onChange: (e) =>
//                   formik?.setFieldValue(`answer[${0}]`, e.target.value), // Update the value in the array
//               })}
//             rows={3}
//           />
//         )}
//         {values?.input_type === "dropdown" && (
//           <>
//             <select
//               id="answer"

//               className={`w-100 p-2 select_css ${
//                 formik?.errors?.answer && formik?.touched?.answer
//                   ? "is-invalid border-danger"
//                   : ""
//               }`}
//               value={values?.answer !== null ? values?.answer[0] : ""}
//               name={`answer[${0}]`}
//               {...(subQuestion
//                 ? {
//                     onChange: (e) =>
//                       handleSubQuestionChange(index, [e.target.value], "answer"),
//                   }
//                 : {
//                     onChange: (e) =>
//                       formik?.setFieldValue(`answer[${0}]`, e.target.value), // Update the value in the array
//                   })}
//               //   className={`w-100 p-2 select_css ${
//               //     disabled && "bg-disabled"
//               //   } ${
//               //     formik.errors.input_type && formik.touched.input_type
//               //       ? "is-invalid border-danger"
//               //       : ""
//               //   }`}
//             >
//               <option value="">Select an option</option>
//               {values?.dropdown_type === "custom"
//                 ? values?.options?.map((option, index) => (
//                     <option key={index} value={option}>
//                       {option}
//                     </option>
//                   ))
//                 : null}
//               {values?.dropdown_type === "numeric"
//                 ? mappedValues?.length > 1 &&
//                   mappedValues?.map((value, index) => (
//                     <option key={index} value={value}>
//                       {value}
//                     </option>
//                   ))
//                 : null}
//               {values?.dropdown_type === "autogenerate"
//                 ? mappedValues?.map((value, index) => (
//                     <option key={index} value={value}>
//                       {values?.title} {value}
//                     </option>
//                   ))
//                 : null}
//             </select>
//           </>
//         )}

//         {values?.input_type === "checkbox" &&
//           values?.checkbox_type === "single" && (
//             <div className="d-flex">
//               {values?.options?.map((option, index) => (
//                 <div className="form-check mr-3" key={index}>
//                   <input
//                     type="checkbox"
//                     className={`form-check-input ${
//                       formik?.errors?.answer && formik?.touched?.answer
//                         ? "is-invalid border-danger"
//                         : ""
//                     }`}
//                     id={`checkbox-${index}`}
//                     name="answer"
//                     value={option}
//                     checked={values?.answer?.includes(option)}
//                     {...(subQuestion
//                       ? {
//                           onChange: (e) =>
//                             // handleSubQuestionChange(
//                             //   index,
//                             //   e.target.value,
//                             //   "answer"
//                             // ),
//                             handleCheckboxChange(option)
//                         }
//                       : {
//                         onChange: (e) =>
//                           formik?.setFieldValue(`answer[${index}]`, (e.target.checked ? e.target.value : "")), // Update the value in the array
//                       })}
//                     //   disabled
//                   />
//                   <label
//                     className="form-check-label "
//                     htmlFor={`checkbox-${index}`}
//                   >
//                     {option}
//                   </label>
//                 </div>
//               ))}
//             </div>
//           )}

//         {values?.input_type === "radio" && (
//           <div className="d-flex">
//             {values?.options?.map((option, index) => (
//               <div className="form-check mr-3" key={index}>
//                 <input
//                   type="radio"
//                   value={option}
//                   checked={values?.answer !== null ? option === values?.answer[0] : ""}
//                   className={`form-check-input ${
//                     formik?.errors?.answer && formik?.touched?.answer
//                       ? "is-invalid border-danger"
//                       : ""
//                   }`}
//                   id={`radio-${index}`}

//                 // value={values?.answer[0] || ""}
//             //   name={`answer[${0}]`}
//                   {...(subQuestion
//                     ? {
//                         onChange: (e) =>
//                           handleSubQuestionChange(index, [e.target.value], "answer"),
//                       }
//                     : {
//                         onChange: (e) =>
//                           formik?.setFieldValue(`answer[${0}]`, e.target.value), // Update the value in the array
//                       })}
//                 />
//                 <label className="form-check-label " htmlFor={`radio-${index}`}>
//                   {option}
//                 </label>
//               </div>
//             ))}
//           </div>
//         )}
//         {formik?.errors?.answer && formik?.touched?.answer && (
//           <span className="invalid-feedback">{formik?.errors?.answer}</span>
//         )}
//       </div>
//     </div>
//   );
// }

// export default AuditFormAnswerFieldUi;

import React, { useEffect, useState } from "react";
import $ from "jquery";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./style.css";
import {
  convertDDMMYYYY,
  convertMMDDYYYY,
  convertToFullDate,
} from "../../Utils/function";
function AuditFormAnswerFieldUi({
  values,
  index,
  subIndex,
  subQuestion,
  setBoxes,
  boxes,
  formik,
  error,
  setError,
  validateQuestions,
}) {
  const [mappedValues, setMappedValues] = useState([]);
  const [selectedNumber, setSelectedNumber] = useState(0);
  const [inputValues, setInputValues] = useState([]);

  const handleSelectChange = (e) => {
    const number = parseInt(e.target.value, 10);
    setSelectedNumber(number);

    // Reset input values based on the new selection
    setInputValues(Array(number).fill(""));
  };

  const handleInputChange = (index, value, currentQuestionIndex) => {
    const updatedInputs = [...inputValues];
    updatedInputs[index] = value;
    setInputValues(updatedInputs);
    let data = [...boxes];
    data[currentQuestionIndex].user_answer = updatedInputs;
    setBoxes(data);
  };
console.log(boxes,'BOXES')
  useEffect(() => {
    // Calculate the difference between b and a
    const difference = parseFloat(values?.max) - parseFloat(values?.min);
    // Create an array of mapped values
    const valuesT = [];
    for (let i = 0; i <= difference; i++) {
      const mappedValue = parseFloat(values?.min) + i;
      valuesT.push(mappedValue);
    }
    // Set the mapped values to state
    if (valuesT.length > 1) {
      setMappedValues(valuesT);
    }
  }, [values?.min, values?.max]);
  useEffect(() => {
    if (
      values?.dropdown_type == "autogenerate" &&
      values?.user_answer &&
      values?.user_answer.length > 0
    ) {
      setSelectedNumber(values.user_answer?.length);
      setInputValues(values.user_answer);
    }
  }, [values]);
  // const handleCheckboxChange = (option) => {
  //   const currentAnswers = values?.answer || [];
  //   const newAnswers = currentAnswers.includes(option)
  //     ? currentAnswers.filter((item) => item !== option) // Remove if already selected
  //     : [...currentAnswers, option]; // Add if not selected
  //   if (subQuestion) {
  //     // handleSubQuestionChange(index, newAnswers, "answer");
  //   }
  // };
  const handleCheckboxChange = (index, subIndex, option) => {
    const updatedBoxes = boxes.map((box, i) => {
      if (i === index) {
        const updatedSubQuestions = box?.sub_question?.map((subQuestion, j) => {
          if (j === subIndex) {
            const currentAnswers = subQuestion.user_answer || [];
            const newAnswers = currentAnswers?.includes(option)
              ? currentAnswers?.filter((item) => item !== option) // Remove if already selected
              : [...currentAnswers, option]; // Add if not selected
            return { ...subQuestion, user_answer: newAnswers };
          }
          return subQuestion;
        });
        return { ...box, sub_question: updatedSubQuestions };
      }
      return box;
    });

    setBoxes(updatedBoxes);
  };

  const handleSubQuestionChange = (index, subIndex, value) => {
    const updatedBoxes = boxes.map((box, i) => {
      if (i === index) {
        const updatedSubQuestions = box?.sub_question?.map((subQuestion, j) => {
          if (j === subIndex) {
            return { ...subQuestion, user_answer: [value] }; // Update the specific key
          }
          return subQuestion;
        });
        return { ...box, sub_question: updatedSubQuestions };
      }
      return box;
    });

    setBoxes(updatedBoxes);
  };
  const handleChange = (index, value) => {
    const updatedBoxes = boxes?.map((box, i) =>
      i === index ? { ...box, user_answer: [value] } : box
    );

    setBoxes(updatedBoxes);
  };
  const handleRadioChange = (index, value) => {
    const updatedBoxes = boxes?.map((box, i) =>
      i === index ? { ...box, user_answer: [value] } : box
    );

    setBoxes(updatedBoxes);
  };
  const handleCheckboxChangeq = (index, option) => {
    const updatedBoxes = boxes?.map((box, i) => {
      if (i === index) {
        const currentAnswers = box?.user_answer || [];
        const newAnswers = currentAnswers?.includes(option)
          ? currentAnswers?.filter((item) => item !== option) // Remove if already selected
          : [...currentAnswers, option]; // Add if not selected
        return { ...box, user_answer: newAnswers };
      }
      return box;
    });

    setBoxes(updatedBoxes);
  };
  const [selectedDate, setSelectedDate] = useState(null);
  return (
    <div className="row">
      <div></div>
      <div className="col-6">
        {values?.input_type === "date" && (
          //     <div class="input-group date" id="reservationdate" data-target-input="nearest">
          //     <input type="text" class="form-control datetimepicker-input" data-target="#reservationdate"/>
          //     <div class="input-group-append" data-target="#reservationdate" data-toggle="datetimepicker">
          //         <div class="input-group-text"><i class="fa fa-calendar"></i></div>
          //     </div>
          // </div>
          <div className="input-group date" style={{ width: "100%" }}>
            <DatePicker
              selected={
                Array.isArray(values?.user_answer) &&
                values?.user_answer.length > 0
                  ? convertToFullDate(values?.user_answer[0])
                  : new Date()
              }
              onBlur={(e) => {
                if (!e.target.value) {
                  // Optional: Reset the date if the input is cleared
                  if (subQuestion) {
                    handleSubQuestionChange(
                      index,
                      subIndex,
                      convertDDMMYYYY(new Date())
                    );
                  } else {
                    handleChange(index, convertDDMMYYYY(new Date()));
                  }
                }
              }}
              name={`user_answer[${0}]`}
              {...(subQuestion
                ? {
                    onChange: (date) =>
                      handleSubQuestionChange(
                        index,
                        subIndex,
                        convertDDMMYYYY(date)
                      ),
                  }
                : {
                    onChange: (date) =>
                      handleChange(index, convertDDMMYYYY(date)),
                  })}
              dateFormat="dd/MM/yyyy" // Adjust format as needed
              className={`form-control datetimepicker-input${
                error?.err ? "is-invalid border-danger" : ""
              }`}
              placeholderText="Select a date"
            />
            <div className="input-group-append">
              <div className="input-group-text">
                <i className="fa fa-calendar"></i>
              </div>
            </div>
          </div>
        )}
        {/* values?.question !== 'City' && */}
        { values?.input_type === "text" && !values?.multiline && (
          <input
            type="text"
            className={`form-control ${
              error?.err ? "is-invalid border-danger" : ""
            }`}
            value={
              Array.isArray(values?.user_answer) &&
              values?.user_answer.length > 0
                ? values?.user_answer[0]
                : ""
            }
            name={`user_answer[${0}]`}
            placeholder="Enter Answer"
            {...(subQuestion
              ? {
                  onChange: (e) =>
                    handleSubQuestionChange(index, subIndex, e.target.value),
                }
              : {
                  onChange: (e) => handleChange(index, e.target.value),
                })}
          />
        )}
        {values?.input_type === "text" && values?.multiline && (
          <textarea
            type="text"
            className={`form-control ${
              error?.err ? "is-invalid border-danger" : ""
            }`}
            placeholder="Enter Answer"
            value={
              Array.isArray(values?.user_answer) &&
              values?.user_answer.length > 0
                ? values?.user_answer[0]
                : ""
            }
            name={`user_answer[${0}]`}
            {...(subQuestion
              ? {
                  onChange: (e) =>
                    handleSubQuestionChange(index, subIndex, e.target.value),
                }
              : {
                  onChange: (e) => handleChange(index, e.target.value),
                })}
            rows={3}
          />
        )}
        {values?.input_type === "dropdown" && (
          <>
            <div>
              <select
                id="answer"
                className={`w-100 p-2 select_css`}
                value={selectedNumber || ""}
                onChange={handleSelectChange}
              >
                <option value="">Select a number</option>
                {values?.dropdown_type === "custom" &&
                  values?.options?.map((option, index) => (
                    <option key={index} value={option}>
                      {option}
                    </option>
                  ))}
                {values?.dropdown_type === "numeric" &&
                  mappedValues?.map((value, index) => (
                    <option key={index} value={value}>
                      {value}
                    </option>
                  ))}
                {values?.dropdown_type === "autogenerate" &&
                  mappedValues?.map((value, index) => (
                    <option key={index} value={value}>
                      {value}
                    </option>
                  ))}
              </select>

              {/* Render input fields based on the selected number */}
              <div className="mt-3">
                {Array.from({ length: selectedNumber }).map((_, ind) => (
                  <>
                    <label>
                      Q. {index + 1} {ind + 1}
                      {")"} {values?.title}{" "}
                    </label>

                    <input
                      key={ind}
                      type="text"
                      value={ values?.user_answer[ind] || inputValues[ind] || ""}
                      onChange={(e) =>
                        handleInputChange(ind, e.target.value, index)
                      }
                      placeholder={`Enter Here`}
                      className="form-control mb-2"
                    />
                  </>
                ))}
              </div>
            </div>
          </>
        )}

        {values?.input_type === "checkbox" &&
          values?.checkbox_type === "single" && (
            <div className="d-flex">
              {values?.options?.map((option, ind) => (
                <div className="form-check mr-3" key={ind}>
                  <input
                    type="checkbox"
                    className={`form-check-input ${
                      error?.err ? "is-invalid border-danger" : ""
                    }`}
                    id={`checkbox-${ind}`}
                    name="answer"
                    value={option}
                    checked={
                      Array.isArray(values?.user_answer) &&
                      values?.user_answer.length > 0 &&
                      values?.user_answer?.includes(option)
                    }
                    {...(subQuestion
                      ? {
                          onChange: (e) =>
                            // handleSubQuestionChange(
                            //   index,
                            //   e.target.value,
                            //   "answer"
                            // ),
                            handleCheckboxChange(index, subIndex, option),
                        }
                      : {
                          onChange: (e) =>
                            // handleCheckboxChangeq(index,(e.target.checked ? e.target.value : ""))
                            handleCheckboxChangeq(index, option),
                          // formik?.setFieldValue(`answer[${ind}]`, (e.target.checked ? e.target.value : "")), // Update the value in the array
                        })}
                    //   disabled
                  />
                  <label
                    className="form-check-label "
                    htmlFor={`checkbox-${ind}`}
                  >
                    {option}
                  </label>
                </div>
              ))}
            </div>
          )}

        {values?.input_type === "radio" && (
          <div className="d-flex">
            {values?.options?.map((option, ind) => (
              <div className="form-check mr-3" key={ind}>
                <input
                  type="radio"
                  value={option}
                  checked={
                    Array.isArray(values?.user_answer) &&
                    values?.user_answer.length > 0 &&
                    option === values?.user_answer[0]
                  }
                  className={`form-check-input ${
                    error?.err ? "is-invalid border-danger" : ""
                  }`}
                  // id={`radio-${ind}`}
                  // value={values?.answer[0] || ""}
                  //   name={`answer[${0}]`}
                  {...(subQuestion
                    ? {
                        onChange: (e) =>
                          handleSubQuestionChange(
                            index,
                            subIndex,
                            e.target.value
                          ),
                      }
                    : {
                        onChange: (e) =>
                          handleRadioChange(index, e.target.value),
                      })}
                />
                <label className="form-check-label " htmlFor={`radio-${ind}`}>
                  {option}
                </label>
              </div>
            ))}
          </div>
        )}
      </div>
      {error?.err ? <span className="err-msg">{error?.err}</span> : null}
    </div>
  );
}

export default AuditFormAnswerFieldUi;
